import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import uasRaichur from "../../assets/uasRaichur.jpg";
import { useAppContext } from "../../context/AppContext";
import BackButton from "../common/BackButton";
import LogoutButton from "../common/LogoutButton";
import { useLocation } from "react-router-dom";

export default function NavBar() {
  const { customer, loadingCustomer, user } = useAppContext();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  if (loadingCustomer) return null;

  const logoSrc = customer?.logoPath || uasRaichur;
  const organizationName = customer?.displayName || "Agriculture Tech";

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "#18693c",
        height: { xs: 70, md: 100 },
        justifyContent: "center",
        px: { xs: 1.5, md: 4 },
        borderRadius:0,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: { xs: "70px", md: "100px" },
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* ===== LEFT SECTION (Back + Logo) ===== */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {user && !isHomePage && <BackButton />}

          <Box
            component="img"
            src={logoSrc}
            alt="Logo"
            sx={{
              width: { xs: 45, md: 90 },
              height: { xs: 45, md: 85 },
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </Box>

        {/* ===== TITLE ===== */}
        <Box
          sx={{
            flex: 1,
            textAlign: "center",
            px: 1,
          }}
        >
          <Typography
            noWrap
            sx={{
              fontWeight: 700,
              color: "#fff",
              fontSize: { xs: "14.5px", sm: "20px", md: "28px" },
              lineHeight: 1.2,
            }}
          >
            {organizationName}
          </Typography>
        </Box>

        {/* ===== RIGHT SECTION (Logout) ===== */}
        <Box sx={{ ml: 1 }}>
          {user && <LogoutButton />}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
